// ** React Imports
import React, { useState, useEffect } from "react";

// ** Third Party Components
import PropTypes from "prop-types";

// #####################################################

const NavigationArrow = ({ direction, swiper }) => {
	const [showArrow, setShowArrow] = useState(true);
	const [dragging, setDragging] = useState(false);

	useEffect(() => {
		if (swiper?.isBeginning || swiper?.isEnd) {
			setShowArrow(false);
		}
	}, [swiper?.isBeginning, swiper?.isEnd]);

	// #####################################################

	return (
		((direction === "prev" && !swiper?.isBeginning) ||
			(direction === "next" && !swiper?.isEnd) ||
			(swiper?.isBeginning && swiper?.isEnd)) && (
			<button
				type="button"
				className={`swiper-button-${direction}`}
				onMouseEnter={() => {
					setShowArrow(true);
				}}
				onMouseOut={() => {
					setShowArrow(false);
				}}
				onBlur={(e) => {
					e.preventDefault();
				}}
				onClick={(e) => {
					e.preventDefault();
					if (!dragging) {
						direction === "prev"
							? swiper.slidePrev()
							: swiper.slideNext();
					}
				}}
				draggable
				onDragStart={(e) => {
					e.preventDefault();
					setShowArrow(false);
					direction === "prev"
						? swiper.slidePrev()
						: swiper.slideNext();
				}}
				onDrag={(e) => {
					setDragging(true);
					e.preventDefault();
				}}
				onDragEnd={(e) => {
					e.preventDefault();
					setShowArrow(true);
					setDragging(false);
				}}
				style={
					direction === "prev"
						? {
								"--swiper-navigation-color": showArrow
									? "rgba(255, 255, 255, 0.65)"
									: "transparent",

								left: 0,
								top: 0,
								minWidth: "80px",
								width: "15%",
								padding: "0 0 0 1rem",
								alignItems: "left",
								justifyContent: "left",
						  }
						: {
								"--swiper-navigation-color": showArrow
									? "rgba(255, 255, 255, 0.65)"
									: "transparent",
								minWidth: "80px",
								right: 0,
								top: 0,
								height: "calc(100% - 150px)",
								width: "15%",
								padding: "0 1rem 0 0",
								alignItems: "right",
								justifyContent: "right",
						  }
				}
			>
				{" "}
			</button>
		)
	);
};

// #####################################################

NavigationArrow.propTypes = {
	direction: PropTypes.oneOf(["next", "prev"]).isRequired,
};

export default NavigationArrow;
